// extracted by mini-css-extract-plugin
module.exports = {"list-item":"Applications_list-item__2Vnfj","active":"Applications_active__2VAdx"};